<div class="spacer"></div>

<style lang="scss">
  .spacer {
    flex-grow: 1;
  }
</style>